import { Box } from '@mui/material';
import { Fragment, useRef } from 'react';

import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';

import { Answer } from './components/Answer';
import { BotTyping } from './components/BotTyping';
import { ErrorState } from './components/ErrorState';
import { Question } from './components/Question';
import { Skeleton } from './components/Skeleton';
import { Wrapper } from './components/Wrapper';
import { useScrollToChatsBottom } from './hooks';

import type { FC } from 'react';

export const Body: FC = () => {
  const lastItemRef = useRef<HTMLDivElement>(null);
  const {
    data,
    isLoadingAnswer,
    isLoadingChat,
    isLoadingChatTopics,
    isError,
    shouldScrollToBottom,
  } = useParentHelperContext();

  useScrollToChatsBottom(lastItemRef, data, shouldScrollToBottom);

  if (isLoadingChatTopics || isLoadingChat) {
    return (
      <Wrapper>
        <Skeleton />
      </Wrapper>
    );
  }

  if (isError) {
    return (
      <Wrapper>
        <ErrorState />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {data.map(
        ({
          id,
          question,
          answer,
          withoutAvatar,
          isAnswerLiked,
          withoutFeedback,
        }) => (
          <Fragment key={id}>
            <Question question={question} withoutAvatar={withoutAvatar} />
            <Answer
              answer={answer}
              messageId={id}
              withoutAvatar={withoutAvatar}
              isAnswerLiked={isAnswerLiked}
              withoutFeedback={withoutFeedback}
            />
          </Fragment>
        ),
      )}
      {isLoadingAnswer && <BotTyping />}
      <Box ref={lastItemRef} />
    </Wrapper>
  );
};
